import { render, staticRenderFns } from "./CustomBlock.vue?vue&type=template&id=0af4127a&"
import script from "./CustomBlock.vue?vue&type=script&lang=js&"
export * from "./CustomBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports